import { useState } from 'react';
import { useCalibrationState } from '../context/CalibrationPageContext';
import {
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextFeild,
  TextField,
  Typography,
} from '@mui/material';
import NewSensorDetails from './add_calibrations/NewSensorDetails';
import PreviewSensors from './add_calibrations/PreviewSensors';

import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';



function AddCalibrations() {
  const { 
    sensors, setSensors, 
    selectedSensorType, setSelectedSensorType, 
    serialNumber, setSerialNumber, 
    calFactor, setCalFactor, 
    testDate, setTestDate, 
    handleSensorChange, 
    resetNewSensorDetails, 
    addSensor, 
    removeSensor 
  } = useCalibrationState();

  return (
    <Box display='flex' height='100%' width='100%' alignItems='center' justifyContent='center' sx={{ overflowY: 'auto', scrollbarWidth: 'none' }}>
      <Box
        sx={{
          mt: { md: 0, sm: 9, xs: 0 },
          p: { xs: 1, sm: 2 },
          height: { xs: 'auto', md: '100%' },
          width: { xs: '100%', md: '70%' },
          backgroundColor: 'background.paper',
          borderRadius: 1, border: '1px solid',
          borderColor: 'divider'
        }}
      >
        <Typography variant='h6' fontSize={{ md: 18, sm: 16 }} sx={{ mb: 1 }}>
          Add Sensors
        </Typography>

        {/* Side by side on a desktop; stacked on a phone */}
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={1}
          sx={{
            height: { xs: 'auto', md: 'calc(100% - 40px)' },
            width: '100%'
          }}
        >
          {/* Sensor Detail Pane */}
          <NewSensorDetails />

          {/* Preview Pane */}
          <PreviewSensors />

        </Stack>

      </Box>
    </Box>
  );
}

export default AddCalibrations;